export const environment = {
  production: true,
  API_URL: 'https://ivi-test.ifs.be',
  //API_URL: 'https://ifsobs-service.azurewebsites.net',
  Base_url: '/',
  UserFilesFolderName: 'users-files',

  dataSecretKey: '6LciKDUUAAAAAAPdT7e5hEG7PcrbDDEZQh-8m16H',

  prodDataSecretKey: '6Ld3JzUUAAAAAPoylAfCF4DXvejNv53L1d6q_Bxn',
  testDataSecretKey: '6LdFJjUUAAAAALiHDVjoZHCr3XuReR3ol0PSKBBQ',
  devDataSecretKey: '6LciKDUUAAAAAAPdT7e5hEG7PcrbDDEZQh-8m16H',

};
